import * as React from 'react';
import classNames from 'clsx';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { ButtonLink } from '../ButtonLink';
import * as styles from './styles.css';

export interface IToggleButtonProps {
  children: React.ReactNode;
  isOpened: boolean;
  onClick(e: React.MouseEvent<HTMLElement>): void;
}

export function ToggleButton({ children, isOpened, onClick }: IToggleButtonProps) {
  return (
    <ButtonLink onClick={onClick}>
      {children}&nbsp;
      <span className={classNames(styles['icon'], isOpened && styles['icon--opened'])}>
        <IconActionChevronDownSmall16 color="icon-main-default" display="inline-block" />
      </span>
    </ButtonLink>
  );
}
